import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { Grid, TextField, Autocomplete } from "@mui/material";

import { PAYMENTS_PHRASE } from "./config";

import { selectAccount } from "redux/actions/buildings/payments/paymentsActions";


export const PaymentsTableInputs = () => {
  const dispatch = useDispatch();

  const { accounts, accountSelected, station } = useSelector(state => state.payments);

  const handleChangeAccount = (e, v) => {
    dispatch(selectAccount(v));
  };

  useEffect(() => {
    dispatch(selectAccount(null));
  }, [station])

  return (
    <>
      <Grid item xs={12} sm={5} >
        <Autocomplete
          options={accounts}
          disableClearable
          getOptionLabel={option => option.label}
          disabled={accounts?.length === 0}
          value={accountSelected}
          renderInput={params => (
            <TextField
              {...params}
              name="routeCycles"
              label={PAYMENTS_PHRASE.page.table.header.dropdown.label}
              variant="outlined"
              size="small"
            />
          )}
          fullWidth
          onChange={(e, v) => handleChangeAccount(e, v)}
          noOptionsText={
            PAYMENTS_PHRASE.page.table.header.dropdown.noOptions
          }
        />
      </Grid>
    </>
  );
};
